import { Button, ClickAwayListener, Fade, Paper, Popper, Typography } from '@material-ui/core'
import { ExpandMore as ExpandMoreIcon } from '@material-ui/icons'
import { MouseEvent, useRef, useState } from 'react'

import { CategorySub } from '@karakuri-web/faq-type'

import { Category } from './Category'

export interface Props {
  categories: CategorySub[]
  onSelect: (c: null | CategorySub) => void
}
export function CategorySelector({ categories, onSelect }: Props) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [current, setCurrent] = useState<null | CategorySub>(null)
  const arrowRef = useRef(null)

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }
  const handleClickAway = () => {
    setAnchorEl(null)
  }
  const handleSelect = (c: null | CategorySub) => {
    setAnchorEl(null)
    setCurrent(c)
    onSelect(c)
  }
  const open = Boolean(anchorEl)
  const id = open ? 'category-selector' : undefined

  return (
    <div className="category-selector">
      <Button
        className="category-selector__button"
        variant="outlined"
        aria-describedby={id}
        onClick={handleClick}
        startIcon={<ExpandMoreIcon />}
      >
        {(current && current.title) || 'カテゴリで絞る'}
      </Button>

      <Popper
        id={id}
        open={open}
        anchorEl={anchorEl}
        transition
        placement="bottom-start"
        disablePortal={false}
        modifiers={{
          flip: {
            enabled: true,
          },
          preventOverflow: {
            enabled: true,
            boundariesElement: 'scrollParent',
          },
          arrow: {
            enabled: false,
            element: arrowRef,
          },
        }}
        className="category-selector__popper"
      >
        {({ TransitionProps }) => (
          <ClickAwayListener onClickAway={handleClickAway}>
            <Fade {...TransitionProps} timeout={350}>
              <div className="category-selector__wrapper">
                <div className="arrow" ref={arrowRef} />
                <Paper className="category-selector__paper" square>
                  <Typography variant="h2" className="category-selector__title">
                    カテゴリを選択してください
                  </Typography>
                  <Category categories={categories} onSelect={handleSelect} />
                </Paper>
              </div>
            </Fade>
          </ClickAwayListener>
        )}
      </Popper>
    </div>
  )
}
